// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3Ov7I","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3E5bS"};